<template>
  <div class="rust-contract-detector contract-detector">
    <common-bg-plate>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane v-if="$utils.hasAuth($store, auth.contractdetector.rust.contractManage)" label="合约管理" name="contract">
          <action-bar>
            <search
              v-model="contractKey"
              placeholder="请输入ID/合约名"
              @onSearch="onSearchContracts"
            ></search>
            <btn-style :btn-list="cBtnList"></btn-style>
            <div class="fill"></div>
          </action-bar>
          <rust-contract-list
            ref="contract"
            @goDetail="onGoContractDetail"
            @popConfirmDelete="onPopConfirmDelete"
          ></rust-contract-list>
        </el-tab-pane>
        <el-tab-pane v-if="$utils.hasAuth($store, auth.contractdetector.rust.taskManage)" label="任务管理" name="task">
          <action-bar>
            <search
              v-model="taskKey"
              placeholder="请输入合约ID/合约名"
              @onSearch="onSearchTasks"
            ></search>
            <btn-style :btn-list="tBtnList"></btn-style>
            <div class="fill"></div>
            <el-checkbox v-model="onlyUnfinished" class="action-bar-checkbox" @change="onShowModeChanged"
              >只看未完成</el-checkbox
            >
            <btn-style :btn-list="tBtnList2"></btn-style>
          </action-bar>
          <rust-task-list
            ref="task"
            @goDetail="onGoTaskDetail"
            @popConfirmRestart="onPopConfirmRestart"
          ></rust-task-list>
        </el-tab-pane>
      </el-tabs>
    </common-bg-plate>
    <add-rust-contract
      :dialog-visible.sync="showAddRustContract"
      @addSuccess="onAddContractSuccess"
    ></add-rust-contract>
    <delete-rust-contract
      :contract-info="contractInfo"
      :dialog-visible.sync="showDeleteRustContract"
      @deleteSuccess="onDeleteContractSuccess"
    ></delete-rust-contract>
    <restart-rust-detector-task
      :task-info="taskInfo"
      :dialog-visible.sync="showRestartRustDetectorTask"
      @restartSuccess="onRestartTaskSuccess"
    ></restart-rust-detector-task>
    <create-rust-detector-task
      :dialog-visible.sync="showCreateRustDetectorTask"
      @createSuccess="onCreateTaskSuccess"
    ></create-rust-detector-task>
  </div>
</template>

<script>
import auth from '@/auth/index'
import { mapState, mapActions } from 'vuex'
import rustContractList from './components/rustContractList'
import rustTaskList from './components/rustTaskList'
import addRustContract from './addRustContract'
import deleteRustContract from './deleteRustContract'
import restartRustDetectorTask from './restartRustDetectorTask'
import createRustDetectorTask from './createRustDetectorTask'

export default {
  name: 'RustContractDetector',
  components: {
    rustContractList,
    rustTaskList,
    addRustContract,
    deleteRustContract,
    restartRustDetectorTask,
    createRustDetectorTask
  },
  data() {
    return {
      activeName: 'contract',
      contractKey: '',
      taskKey: '',
      onlyUnfinished: false,
      showAddRustContract: false,
      showDeleteRustContract: false,
      contractInfo: {
        ID: '',
        Filename: '',
        TaskCount: 0,
        CreatedAt: 0,
        UpdatedAt: 0
      },
      showCreateRustDetectorTask: false,
      showRestartRustDetectorTask: false,
      taskInfo: {
        ID: '',
        ContractID: '',
        ContractFilename: '',
        Status: 0,
        CreatedAt: 0,
        StartedAt: 0,
        FinishedAt: 0
      },
      cBtnList: [
        {
          btnContent: '上传合约',
          click: () => {
            return this.onUploadContract()
          },
          icon: 'icon-gen',
          auth: auth.contractdetector.rust.contractManage.upload
        }
      ],
      tBtnList: [
        {
          btnContent: '创建任务',
          click: () => {
            return this.onCreateTask()
          },
          icon: 'icon-gen',
          auth: auth.contractdetector.rust.taskManage.create
        }
      ],
      tBtnList2: [
        {
          btnContent: '刷新',
          click: () => {
            return this.onRefreshTaskList()
          },
          icon: 'icon-refresh',
          type: 'default',
          auth: auth.contractdetector.rust.taskManage.refresh
        }
      ],
      auth: auth
    }
  },
  computed: {
    ...mapState({
      rustPageTab: state => state.contractdetector.rustTab
    })
  },
  mounted() {
    this.activeName = this.rustPageTab
    this.$refs[this.activeName]?.refresh(
      this.activeName == 'contract' ? this.contractKey : this.taskKey,
      this.onlyUnfinished
    )
  },
  methods: {
    ...mapActions(['setRustPageTab']),
    handleClick(tab) {
      this.$refs[tab.name]?.refresh(
        tab.name == 'contract' ? this.contractKey : this.taskKey,
        this.onlyUnfinished
      )
      this.setRustPageTab(tab.name)
    },
    onUploadContract() {
      this.showAddRustContract = true
    },
    onSearchContracts() {
      this.onRefreshContractList()
    },
    onAddContractSuccess() {
      this.onRefreshContractList()
    },
    onDeleteContractSuccess() {
      this.onRefreshContractList()
    },
    onRefreshContractList() {
      this.$refs.contract.refresh(this.contractKey)
    },
    onGoContractDetail(row) {
      this.contractInfo = row
      this.$router.push({
        name: 'rustContractDetail',
        query: {
          contractId: this.contractInfo.ID
        }
      })
    },
    onPopConfirmDelete(row) {
      this.contractInfo = row
      this.showDeleteRustContract = true
    },
    onGoTaskDetail(row) {
      this.taskInfo = row
      this.$router.push({
        name: 'rustTaskDetail',
        query: {
          taskId: this.taskInfo.ID
        }
      })
    },
    onPopConfirmRestart(row) {
      this.taskInfo = row
      this.showRestartRustDetectorTask = true
    },
    onCreateTask() {
      this.showCreateRustDetectorTask = true
    },
    onSearchTasks() {
      this.onRefreshTaskList()
    },
    onRefreshTaskList() {
      this.$refs.task.refresh(this.taskKey, this.onlyUnfinished)
    },
    onCreateTaskSuccess() {
      this.onRefreshTaskList()
    },
    onRestartTaskSuccess() {
      this.onRefreshTaskList()
    },
    onShowModeChanged() {
      this.onRefreshTaskList()
    }
  }
}
</script>

<style scoped lang="scss">
.rust-contract-detector {
  min-height: var(--base-main-router-body-avaliable-height);

  .action-bar-checkbox {
    margin-right: var(--base-size-16);
    line-height: var(--base-size-32);
  }
}
</style>
